module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('headerTop', {
    attrs: {
      "value": "1"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "listw flexcenter"
  }, [_c('div', {
    staticClass: "flexleft"
  }, _vm._l((_vm.swiperList.length), function(item, index) {
    return _c('div', {
      class: _vm.swiperCurrent == index ? 'childs' : 'child',
      on: {
        "click": function($event) {
          return _vm.toIndex(index)
        }
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "swipers"
  }, [_c('el-carousel', {
    ref: "carousel",
    attrs: {
      "trigger": "click",
      "height": "650px",
      "arrow": "never"
    },
    on: {
      "change": _vm.swiperChange
    }
  }, _vm._l((_vm.swiperList), function(item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('div', {
      staticClass: "swiperImg",
      style: ({
        backgroundImage: 'url(' + _vm.$index.addurl(item.image) + ')'
      })
    }, [_c('div', {
      staticClass: "swiperImgCon",
      staticStyle: {
        "background-color": "rgba(0, 0, 0, 0.2)"
      }
    }, [_c('div', {
      staticClass: "lTitle animation-from-left-0"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "bTitle animation-from-right-1"
    }, [_vm._v(_vm._s(item.subtitle))]), _vm._v(" "), _c('div', {
      staticClass: "sTitle animation-from-left-0"
    }, [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('div', {
      staticClass: "more flexleft",
      on: {
        "click": _vm.tofzLc
      }
    }, [_c('div', {
      staticClass: "txt"
    }, [_vm._v("查看更多")]), _vm._v(" "), _c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/image/youjiantous.png"),
        "alt": ""
      }
    })])])])])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "height": "0",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "tags tagss flexaround animation-from-bottom-0 page-contents"
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "child flexbetween",
      on: {
        "click": function($event) {
          return _vm.toinfo(index)
        }
      }
    }, [_c('div', {
      staticClass: "txt"
    }, [_c('div', {
      staticClass: "top"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "bottom"
    }, [_vm._v(_vm._s(item.title_en))])]), _vm._v(" "), _c('div', {
      staticClass: "icon"
    }, [_c('img', {
      staticClass: "ptImg",
      attrs: {
        "src": _vm.$index.addurl(item.icon_image),
        "alt": ""
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "hovImg",
      attrs: {
        "src": _vm.$index.addurl(item.icon_image1),
        "alt": ""
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "aboutus flexbetween"
  }, [_c('div', {
    staticClass: "left aboutusTxt",
    class: _vm.aboutUs ? 'animation-from-left-0' : ''
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.guangchangData.title_en))]), _vm._v(" "), _c('div', {
    staticClass: "ftitle"
  }, [_vm._v(_vm._s(_vm.guangchangData.title))]), _vm._v(" "), _c('div', {
    staticClass: "contents",
    domProps: {
      "innerHTML": _vm._s(_vm.guangchangData.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "more flexleft",
    on: {
      "click": _vm.tofzLc
    }
  }, [_c('div', {
    staticClass: "txt"
  }, [_vm._v("查看更多")]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), (_vm.guangchangData.images && _vm.guangchangData.images.length) ? _c('div', {
    staticClass: "right"
  }, [(_vm.guangchangData.images[0]) ? _c('img', {
    attrs: {
      "src": _vm.$index.addurl(_vm.guangchangData.images[0]),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.guangchangData.images[1]) ? _c('img', {
    attrs: {
      "src": _vm.$index.addurl(_vm.guangchangData.images[1]),
      "alt": ""
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "procedure"
  }, [_c('div', {
    staticClass: "parent page-content flexbetween"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "title",
    class: {
      'animation-from-top-4': _vm.showBox3
    }
  }, [_vm._v(_vm._s(_vm.jjzcData.subtitle))]), _vm._v(" "), _c('div', {
    staticClass: "contents",
    class: {
      'animation-from-right-2': _vm.showBox3
    }
  }, [_vm._v(_vm._s(_vm.jjzcData.description))]), _vm._v(" "), (_vm.showBox3) ? _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.jjzcData.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "child"
    }, [(index % 2 == 0) ? _c('div', {
      staticClass: "leDiv flexleft",
      class: 'animation-from-right-' + index
    }, [_c('div', {
      staticClass: "numW"
    }, [_c('div', {
      staticClass: "numN"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(item.content))])]) : _c('div', {
      staticClass: "riDiv flexright",
      class: 'animation-from-left-' + index
    }, [_c('div', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('div', {
      staticClass: "numW"
    }, [_c('div', {
      staticClass: "numN"
    }, [_vm._v(_vm._s(index + 1))])])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title",
    class: {
      'animation-from-bottom-2': _vm.showBox3
    }
  }, [_vm._v(_vm._s(_vm.mtgtData.subtitle))]), _vm._v(" "), _c('div', {
    staticClass: "contents",
    class: {
      'animation-from-left-5': _vm.showBox3
    },
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.mtgtData.description) + "\n\t\t\t\t")]), _vm._v(" "), (_vm.showBox3) ? _c('div', {
    staticClass: "line animation-height-open"
  }, _vm._l((6), function(item, index) {
    return _c('div', {
      staticClass: "little"
    }, [_vm._v(_vm._s(index + 1))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.showBox3) ? _vm._l((_vm.mtgtData.list), function(item, index) {
    return _c('div', {
      staticClass: "list flexleft"
    }, [(index % 2 != 0) ? _c('div', {
      staticClass: "lefts",
      class: 'animation-from-right-' + index
    }, [_c('div', {
      staticClass: "toptxt"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "bottomtxt"
    }, [_vm._v(_vm._s(item.description))])]) : _vm._e(), _vm._v(" "), (index % 2 == 0) ? _c('div', {
      staticClass: "rights",
      class: 'animation-from-left-' + index
    }, [_c('div', {
      staticClass: "toptxt"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "bottomtxt"
    }, [_vm._v(_vm._s(item.description))])]) : _vm._e()])
  }) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "activity"
  }, [_c('div', {
    staticClass: "parent page-content"
  }, [_c('div', {
    staticClass: "title",
    class: {
      'animation-from-left-2': _vm.activityBox
    },
    staticStyle: {
      "opacity": "0"
    }
  }, [_vm._v(_vm._s(_vm.ctrData.title) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "contents",
    class: {
      'animation-from-right-5': _vm.activityBox
    },
    staticStyle: {
      "opacity": "0"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.ctrData.description) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "center flexleft"
  }, _vm._l((_vm.ctrData.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "child",
      class: _vm.activityBox ? ("animation-from-bottom-" + index) : '',
      staticStyle: {
        "opacity": "0"
      }
    }, [_c('div', {
      staticClass: "childTitle"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "childBot"
    }, [_c('img', {
      attrs: {
        "src": _vm.$index.addurl(item.image),
        "alt": ""
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "secondzs flexbetween"
  }, [_c('div', {
    staticClass: "left aboutusTxt",
    class: {
      'animation-from-left-2': _vm.activityBoxs
    }
  }, [_c('div', {
    staticClass: "lists flexleft"
  }, _vm._l((_vm.serviceList.length), function(item, index) {
    return _c('div', {
      class: _vm.swiCurrent == index ? 'childs' : 'child',
      on: {
        "click": function($event) {
          return _vm.toIndexs(index)
        }
      }
    })
  }), 0), _vm._v(" "), _c('el-carousel', {
    ref: "carousels",
    attrs: {
      "height": "440px",
      "arrow": "never",
      "indicator-position": "none"
    },
    on: {
      "change": _vm.changeswi
    }
  }, _vm._l((_vm.serviceList), function(item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "titles"
    }, [_vm._v(_vm._s(item.title1))]), _vm._v(" "), _c('div', {
      staticClass: "contents"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('div', {
      staticClass: "more flexleft"
    }, [_c('div', {
      staticClass: "txt"
    }, [_vm._v("查看更多")]), _vm._v(" "), _c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/image/youjiantou.png"),
        "alt": ""
      }
    })])])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'animation-from-right-2': _vm.activityBoxs
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/technologys.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listparent flexcenter",
    class: {
      'animation-from-bottom-2': _vm.activityBoxss
    }
  }, [_c('div', {
    staticClass: "list page-contents flexbetween"
  }, _vm._l((_vm.serviceLists), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "child flexaround",
      on: {
        "click": function($event) {
          return _vm.todetailsss(index)
        }
      }
    }, [_c('div', {
      staticClass: "txt"
    }, [_c('div', {
      staticClass: "top"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "bottom"
    }, [_vm._v(_vm._s(item.title_en))])]), _vm._v(" "), _c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticClass: "hoimg",
      attrs: {
        "src": _vm.$index.addurl(item.icon_image),
        "alt": ""
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "ptimg",
      attrs: {
        "src": _vm.$index.addurl(item.icon_image1),
        "alt": ""
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "partner"
  }, [_c('div', {
    staticClass: "parent page-content"
  }, [_c('div', {
    staticClass: "tabs flexleft"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      class: index == _vm.currentTab ? 'childs' : 'child',
      on: {
        "click": function($event) {
          return _vm.changeCurrent(index)
        }
      }
    }, [_vm._v(" " + _vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "center flexleft"
  }, [_c('img', {
    attrs: {
      "src": _vm.$index.addurl(_vm.activeImg),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('footers')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('audio', [_c('source')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/youjiantou.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71a76a6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
// module id = 1102
// module chunks = 1